import { render, staticRenderFns } from "./CmgMealBuilderPage.vue?vue&type=template&id=6c812bd0&scoped=true&lang=pug"
import script from "./cmg-meal-builder-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-meal-builder-page.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c812bd0",
  null
  
)

export default component.exports